import { __awaiter } from "tslib";
import query from "../RcsbQueries/Yosemite/QueryEntryInstances.graphql";
export class RcsbQueryEntryInstances {
    constructor(getClient) {
        this.getClient = getClient;
    }
    request(requestConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.getClient().request({
                    entry_id: requestConfig.entry_id,
                }, query);
                return response.entry;
            }
            catch (error) {
                console.error(error);
                throw error;
            }
        });
    }
}
//# sourceMappingURL=RcsbQueryEntryInstances.js.map